import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  fill: "none",
  viewBox: "0 0 8 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".65",
      "stroke-width": "1.5",
      d: "m1.5 11 5-5-5-5"
    }, null, -1)
  ]))]))
}
export default { render: render }